// newchat 自建 WS 单例：连 Go 后端 /im/ws?token=<customToken>。
// 移植自 ZhaoHaoWanAPP/src/lib/im/ws-client.ts（去 TS）。指数退避重连 + 30s 心跳 + type→handler 分发。
// 替代旧IM实时收消息；旧 chat 不受影响。
import { GO_BASE_URL } from '@/utils/requestGo'

function wsBase() {
    // http://host:port → ws://host:port
    return GO_BASE_URL.replace(/^http/, 'ws').replace(/\/$/, '')
}

function getToken() {
    let t = window.localStorage.getItem('customToken')
    if (t && t !== 'undefined') {
        try {
            t = JSON.parse(t)
        } catch (e) {
            /* 裸字符串 */
        }
    } else {
        t = ''
    }
    return t
}

class ImSocket {
    constructor() {
        this.ws = null
        this.handlers = new Map()
        this.heartbeat = null
        this.reconnectTimer = null
        this.retryDelay = 1000
        this.explicitClose = false
        this.connecting = false
        this.connected = false
    }

    on(type, fn) {
        if (!this.handlers.has(type)) this.handlers.set(type, new Set())
        this.handlers.get(type).add(fn)
        return () => this.off(type, fn)
    }

    off(type, fn) {
        const set = this.handlers.get(type)
        if (set) set.delete(fn)
    }

    emit(frame) {
        const set = this.handlers.get(frame.type)
        if (set) set.forEach((fn) => fn(frame.payload, frame))
        const any = this.handlers.get('*')
        if (any) any.forEach((fn) => fn(frame.payload, frame))
    }

    send(frame) {
        if (!this.ws || this.ws.readyState !== WebSocket.OPEN) return false
        try {
            this.ws.send(JSON.stringify(frame))
            return true
        } catch (e) {
            return false
        }
    }

    connect() {
        if (this.connecting || (this.ws && this.ws.readyState === WebSocket.OPEN)) return
        const token = getToken()
        if (!token) {
            console.warn('[wsClient] 无 customToken，跳过连接')
            return
        }
        this.explicitClose = false
        this.connecting = true
        const url = `${wsBase()}/im/ws?token=${encodeURIComponent(token)}`
        const ws = new WebSocket(url)
        this.ws = ws

        ws.onopen = () => {
            this.connecting = false
            this.connected = true
            this.retryDelay = 1000
            if (this.heartbeat) clearInterval(this.heartbeat)
            this.heartbeat = setInterval(() => this.send({ type: 'ping' }), 30000)
            this.emit({ type: 'ws.open' })
        }

        ws.onmessage = (ev) => {
            try {
                const data = JSON.parse(ev.data)
                if (data && typeof data.type === 'string') this.emit(data)
            } catch (e) {
                /* 忽略非 JSON 帧 */
            }
        }

        ws.onclose = () => {
            this.connected = false
            this.connecting = false
            if (this.heartbeat) {
                clearInterval(this.heartbeat)
                this.heartbeat = null
            }
            this.emit({ type: 'ws.close' })
            if (this.explicitClose) return
            const delay = Math.min(this.retryDelay, 30000)
            this.retryDelay = Math.min(this.retryDelay * 2, 30000)
            this.reconnectTimer = setTimeout(() => this.connect(), delay)
        }

        ws.onerror = () => {
            // 交给 onclose 处理重连
        }
    }

    disconnect() {
        this.explicitClose = true
        if (this.reconnectTimer) {
            clearTimeout(this.reconnectTimer)
            this.reconnectTimer = null
        }
        if (this.heartbeat) {
            clearInterval(this.heartbeat)
            this.heartbeat = null
        }
        if (this.ws) {
            try {
                this.ws.close()
            } catch (e) {
                /* ignore */
            }
            this.ws = null
        }
        this.connected = false
    }
}

export const imSocket = new ImSocket()
